import { Flex } from '@lemonade-hq/cdk';
import React from 'react';
import styled from 'styled-components';

const Dot = styled.button<{ isActive: boolean }>`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${props => (props.isActive ? '#ff0083' : '#ccc')};
  cursor: pointer;
  padding: 0;
  border: none;
  outline: none;
`;

interface SliderDotButtonProps extends React.ComponentPropsWithRef<'button'> {
  isActive: boolean;
}

export const SliderDotButton: React.FC<SliderDotButtonProps> = ({ children, isActive, ...restProps }) => {
  return (
    <Dot {...restProps} isActive={isActive}>
      {children}
    </Dot>
  );
};

export const SliderDotButtonWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Flex gap="8px" justifyContent="center" mt="20px">
      {children}
    </Flex>
  );
};
